import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import Admin from "@/pages/Organizer";
import GuideWorkspace from "@/pages/GuideWorkspace";
import { Navigate } from "react-router-dom";
import WhatsAppUpdates from "./pages/WhatsAppUpdates";
import Classroom from "./pages/Classroom";
import SchoolClassroom from "./pages/SchoolClassroom";
import Guides from "@/pages/Guides";
import GuideSubmit from "@/pages/GuideSubmit";
import GuideInfo from "@/pages/GuideInfo";
import { ChatWidget } from "@/components/ChatWidget";
import { VirtualGuideWidget } from "@/components/VirtualGuideWidget";

export default function App() {
  return (
    <div className="App">
      <div className="grain" aria-hidden />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/guides" element={<Guides />} />
          <Route path="/guide-submit/:token" element={<GuideSubmit />} />
          <Route path="/guide-info/:token" element={<GuideInfo />} />
          <Route path="/whatsapp" element={<WhatsAppUpdates />} />
          <Route path="/classroom" element={<Classroom />} />
          <Route path="/school-classroom" element={<SchoolClassroom />} />
          <Route path="/organizer" element={<Admin />} />
          <Route path="/guide" element={<GuideWorkspace />} />
          <Route path="/admin" element={<Navigate to="/organizer" replace />} />
        </Routes>
        <ChatWidget />
          <VirtualGuideWidget />
      </BrowserRouter>
    </div>
  );
}
